import { inject } from "@angular/core";
import { Translation, TranslocoLoader } from "@jsverse/transloco";
import { catchError, Observable, of } from "rxjs";
import { PORTAL_API_SERVICE_FACTORY } from "./app.config";

export class TranslocoHttpLoader implements TranslocoLoader {
    private portalApiServiceFactory = inject(PORTAL_API_SERVICE_FACTORY);

    getTranslation(lang: string): Observable<Translation> {
        const result = this.portalApiServiceFactory.createService();
        return result.anonymous(lang).pipe(
            catchError(error => {
                console.error('Error inside portalApi.anonymous(lang):', error);
                return of({});
            })
        );
    }
}
